import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'

export const style: CSSResult = css`
  :host {
    display: contents;
  }

  .body,
  .details {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing08};
  }

  .details[hidden] {
    display: none;
  }
`
